// Module
var code = "<header> </header> <div class=\"component-wrapper\"> <div ui-view class=\"view-animation\"> </div> </div> <footer> </footer>";
// Exports
export default code;